import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { GoogleAnalytics } from '@grandvisionhq/analytics';
import { Selectors, Utils, Actions } from '@grandvisionhq/auth';
import { Context, cartIdVar } from '@grandvisionhq/carts-v2';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { mapPaymentDetailsForOrder } from '../../mappers/data/payment-details-mapper.js';
import { CreateOrderErrors } from '../../mappers/errors-mapping.js';
import { getChangedOptIns, getConsents } from '../../StepShipping/selectors.js';
import { useShouldCreateAccount } from '../common/use-should-create-account.js';
import { mapConsentsToOrderModel } from '../../utils/map-consent-to-order-model.js';

const useCreateOrderDraft = ()=>{
    const intl = useIntl();
    const shouldCreateAccount = useShouldCreateAccount();
    const changedOptIns = useSelector(getChangedOptIns);
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const { cart  } = Context.useCart();
    const optIns = changedOptIns && Utils.createOptInsUpdate(changedOptIns);
    const consents = useSelector(getConsents);
    const { href: callbackHref  } = useLink({
        route: 'auth.callback'
    }) || {};
    const createOrderDraft = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*({ paymentDetails , selectedPaymentMethod , returnUrl  }) {
            var ref;
            const analyticsId = yield GoogleAnalytics.getAnalyticsId().then((id)=>id
            );
            const cartId = cartIdVar();
            const mappedConsents = consents && mapConsentsToOrderModel(consents);
            if (isLoggedIn) {
                Actions.OptInsActions.updateOptIns(changedOptIns);
            }
            let loginRedirectUrl;
            if (shouldCreateAccount) {
                const { protocol , host  } = window.location;
                loginRedirectUrl = `${protocol}//${host}${callbackHref}`;
            }
            if (!cart || !cartId) {
                console.error('No Cart');
                throw CreateOrderErrors.ORDER_CREATION_CALL_FAILED;
            }
            const orderDraft = mapPaymentDetailsForOrder({
                intl,
                cartId,
                totalPrice: cart === null || cart === void 0 ? void 0 : (ref = cart.prices) === null || ref === void 0 ? void 0 : ref.totalPrice,
                returnUrl,
                paymentDetails,
                selectedPaymentMethod
            });
            return swcHelpers.objectSpread({}, orderDraft, analyticsId ? {
                analyticsId
            } : null, optIns ? {
                optIns
            } : null, loginRedirectUrl ? {
                loginRedirectUrl
            } : null, mappedConsents ? {
                consents: mappedConsents
            } : null, {
                shouldCreateAccount
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        callbackHref,
        cart,
        changedOptIns,
        consents,
        intl,
        isLoggedIn,
        optIns,
        shouldCreateAccount
    ]);
    return createOrderDraft;
};

export { useCreateOrderDraft };
//# sourceMappingURL=use-create-order-draft.js.map
